"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginDto = void 0;
class LoginDto {
    username;
    password;
    magicLinkToken;
    fingerprint;
}
exports.LoginDto = LoginDto;
